import type { SymbolDefinition } from "../types.ts";
import { circuitBreaker1p } from "./circuit-breaker-1p.ts";
import { circuitBreaker3p } from "./circuit-breaker-3p.ts";
import { contactor1p } from "./contactor-1p.ts";
import { contactor3p } from "./contactor-3p.ts";
import { disconnector } from "./disconnector.ts";
import { earth } from "./earth.ts";
import { fuse } from "./fuse.ts";
import { generator } from "./generator.ts";
import { indicatorLight } from "./indicator-light.ts";
import { meter } from "./meter.ts";
import { motor3p } from "./motor-3p.ts";
import { motorProtector } from "./motor-protector.ts";
import { powerSupply } from "./power-supply.ts";
import { pushButton } from "./push-button.ts";
import { rcd } from "./rcd.ts";
import { relay } from "./relay.ts";
import { sensor } from "./sensor.ts";
import { socketOutlet } from "./socket-outlet.ts";
import { switchSpst } from "./switch.ts";
import { terminalBlock } from "./terminal.ts";
import { transformer } from "./transformer.ts";

export const ALL_SYMBOLS: readonly SymbolDefinition[] = [
  contactor3p,
  contactor1p,
  circuitBreaker3p,
  circuitBreaker1p,
  disconnector,
  rcd,
  motorProtector,
  fuse,
  motor3p,
  earth,
  socketOutlet,
  transformer,
  generator,
  meter,
  indicatorLight,
  pushButton,
  switchSpst,
  terminalBlock,
  relay,
  sensor,
  powerSupply,
];
